import axios from "axios";
import { getApiUrlFromEnv } from "utils/environment.util";
import { getOrchardUrlFromEnv } from "utils/environment.util";
import { CourseModel, CourseSessionModel, type ApiCourseType, type courseType } from "models/course.model";
import { useNavigate } from "react-router-dom";

export class CoursesService {
    apiUrl = "";
    orchardUrl = "";
    env = process.env.REACT_APP_ENV_VAR ?? "";

    constructor() {
        this.apiUrl = getApiUrlFromEnv(this.env);
        this.orchardUrl = getOrchardUrlFromEnv(this.env);
    }

    getCourses = async () => {
        const token = sessionStorage.getItem('accessToken');
        if (!token) return;
        return await axios
            .get(
                `${this.apiUrl}/api/coursesessions/attending`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(async (res) => {
                const bo = await res?.data;
                if (res.status === 200) {
                    let courses: courseType[] = [];
                    bo.results.map((r: ApiCourseType) => courses = [...courses, new CourseModel(r)])
                    return courses;
                }
                throw new Error(bo.error);
            })
            .catch((error) => {
                throw new Error(error);
            });
    };

    getCourse = async (course: courseType) => {
        const token = sessionStorage.getItem('accessToken');
        const endpoint = course.date ? 'coursesessions' : 'courses';
        if (!token) return;
        return await axios
            .get(
                `${this.apiUrl}/api/${endpoint}/${course.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(async (res) => {
                const bo = await res?.data;
                if (res.status === 200) {
                    let courseSession: courseType = CourseSessionModel.fromApi(bo);
                    return courseSession;
                }
                throw new Error(bo.error);
            })
            .catch((error) => {
                throw new Error(error);
            });
    };

}
